<header
  class="fixed top-0 right-0 z-50 h-[50px] border-b border-gray-200 bg-white transition-all duration-300"
  [ngClass]="{
    'left-0 lg:left-16': sidebarCollapsed(),
    'lg:left-[300px]': !sidebarCollapsed(),
  }"
>
  <nav
    class="relative mx-auto flex h-full w-full items-center gap-2 px-2 md:justify-between md:gap-3 md:px-4 lg:pl-6 lg:pr-6"
  >
    <div class="flex min-w-0 flex-1 items-center gap-x-2">
      <button
        type="button"
        class="inline-flex size-9 shrink-0 items-center justify-center rounded border border-transparent text-gray-800 hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 lg:hidden"
        (click)="handleToggleSidebar()"
        [attr.aria-expanded]="!sidebarCollapsed()"
        aria-controls="admin-sidebar"
        aria-label="Alternar sidebar"
      >
        <span class="sr-only">Alternar sidebar</span>
        <app-bootstrap-icon
          name="list"
          sizeClass="text-base"
          colorClass="text-current"
        />
      </button>

      <span class="min-w-0 truncate text-sm font-medium text-gray-700">
        {{ applicationTitle() }}
      </span>
    </div>

    <button
      type="button"
      class="relative inline-flex size-9 shrink-0 items-center justify-center rounded border border-transparent text-sm font-medium text-gray-800 hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 md:hidden"
      id="header-mobile-nav-toggle"
      aria-controls="header-mobile-nav"
      aria-label="Alternar menu"
      (click)="handleToggleMobileNav()"
      [attr.aria-expanded]="isMobileNavOpen()"
    >
      <span class="sr-only">Alternar menu</span>
      <app-bootstrap-icon
        [name]="isMobileNavOpen() ? 'three-dots' : 'three-dots-vertical'"
        sizeClass="text-base"
        colorClass="text-current"
      />
    </button>

    <div class="hidden flex-wrap items-center justify-evenly gap-x-4 md:flex">
      <div class="relative inline-flex">
        <button
          id="header-notifications-menu-toggle"
          type="button"
          class="relative inline-flex items-center gap-x-2 text-sm font-medium"
          aria-haspopup="menu"
          aria-controls="header-notifications-menu"
          [attr.aria-expanded]="isMenuOpen('notifications')"
          (click)="handleToggleMenu('notifications')"
        >
          <span
            class="inline-flex size-9 items-center justify-center rounded-full text-slate-800 transition hover:text-blue-600"
          >
            <app-bootstrap-icon name="bell-fill" sizeClass="text-base" colorClass="text-current" />
          </span>
          @if (unreadCount() > 0) {
            <span
              class="absolute end-0 top-0 inline-flex size-4 items-center justify-center rounded-full bg-blue-600 text-[0.625rem] font-medium text-white"
            >
              {{ unreadCount() }}
            </span>
          }
        </button>

        <div
          id="header-notifications-menu"
          class="absolute end-0 z-60 mt-[40px] w-80 rounded border border-gray-200 bg-white shadow-lg transition-all duration-200 ease-out"
          role="menu"
          aria-labelledby="header-notifications-menu-toggle"
          [ngClass]="{
            'pointer-events-none translate-y-1 opacity-0': !isMenuOpen('notifications'),
            'translate-y-0 opacity-100': isMenuOpen('notifications'),
          }"
        >
          <div class="flex items-center justify-between border-b border-gray-200 p-4 pb-4">
            <h3 class="text-lg font-semibold text-gray-900">Notificações</h3>
            @if (unreadCount() > 0) {
              <span
                class="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-700"
              >
                {{ unreadCount() }} não lidas
              </span>
            }
          </div>

          <div
            class="max-h-96 overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar]:w-2"
          >
            @for (notification of notifications(); track notification.uuid) {
              <div
                class="flex items-center gap-x-3 border-b border-gray-100 px-4 py-3 transition-colors hover:bg-gray-50"
              >
                <button
                  type="button"
                  class="flex min-w-0 flex-1 items-center gap-x-3 text-left"
                  (click)="handleOpenNotification(notification)"
                >
                  <div
                    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
                    [ngClass]="[notification.icon_bg, notification.icon_color]"
                  >
                    <app-bootstrap-icon [name]="notification.icon" sizeClass="text-base" colorClass="text-current" />
                  </div>

                  <div class="min-w-0 flex-1">
                    <p class="text-sm font-medium text-gray-900">
                      {{ notification.title }}
                    </p>
                    <p class="mt-0.5 text-xs text-gray-600">
                      {{ notification.description }}
                    </p>
                  </div>
                </button>

                <button
                  type="button"
                  class="ml-auto shrink-0 text-gray-400 transition-colors hover:text-gray-600 disabled:opacity-50"
                  [disabled]="dismissingUuid() === notification.uuid"
                  (click)="handleDismissNotification(notification, $event)"
                  aria-label="Marcar como lida"
                >
                  <app-bootstrap-icon name="x-lg" sizeClass="text-sm" colorClass="text-current" />
                </button>
              </div>
            } @empty {
              <div class="flex flex-col items-center justify-center px-4 py-8 text-center">
                <app-bootstrap-icon
                  name="bell-slash"
                  sizeClass="text-3xl"
                  colorClass="mb-2 text-gray-400"
                />
                <p class="text-sm text-gray-600">Nenhuma notificação</p>
              </div>
            }
          </div>

          @if (notifications().length > 0 || unreadCount() > 0) {
            <div class="border-t border-gray-200 p-4 pt-4">
              <button
                type="button"
                class="inline-flex h-10 w-full items-center justify-center rounded bg-blue-600 px-6 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
                (click)="handleViewAllNotifications()"
              >
                Ver todas as notificações
              </button>
            </div>
          }
        </div>
      </div>

      <div class="relative inline-flex">
        <button
          id="header-actions-menu-toggle"
          type="button"
          class="relative inline-flex items-center gap-x-2 text-sm font-medium transition"
          aria-haspopup="menu"
          aria-controls="header-actions-menu"
          [attr.aria-expanded]="isMenuOpen('actions')"
          (click)="handleToggleMenu('actions')"
        >
          <app-user-avatar
            [name]="currentUser().name"
            [imageUrl]="currentUser().avatarUrl"
            sizeClass="size-7"
            textClass="text-xs"
          />
        </button>

        <div
          id="header-actions-menu"
          class="absolute end-0 z-60 mt-[40px] min-w-60 rounded border border-gray-200 bg-white p-2 shadow-lg transition-all duration-200 ease-out"
          role="menu"
          aria-labelledby="header-actions-menu-toggle"
          [ngClass]="{
            'pointer-events-none translate-y-1 opacity-0': !isMenuOpen('actions'),
            'translate-y-0 opacity-100': isMenuOpen('actions'),
          }"
        >
          <div class="mb-2 flex items-center gap-3 border-b border-gray-200 px-2 pb-3 pt-1">
            <app-user-avatar
              [name]="currentUser().name"
              [imageUrl]="currentUser().avatarUrl"
              sizeClass="size-8"
              textClass="text-xs"
            />
            <div class="min-w-0">
              <p class="truncate text-sm font-semibold text-gray-800">
                {{ currentUser().name }}
              </p>
              <p class="truncate text-xs text-gray-500">
                {{ getUserSubtitle() }}
              </p>
            </div>
          </div>

          <a
            [routerLink]="adminRoutePaths.profile"
            class="flex items-center gap-x-3 rounded px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
            (click)="handleCloseMenu('actions')"
          >
            <app-bootstrap-icon name="person" sizeClass="text-base" colorClass="text-current" />
            Perfil
          </a>

          @if (isCompanyAdmin()) {
            <a
              [routerLink]="adminRoutePaths.settings"
              class="flex items-center gap-x-3 rounded px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
              (click)="handleCloseMenu('actions')"
            >
              <app-bootstrap-icon name="gear" sizeClass="text-base" colorClass="text-current" />
              Configurações
            </a>
          }

          <button
            type="button"
            class="flex w-full items-center gap-x-3 rounded px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
            (click)="handleLogout()"
          >
            <app-bootstrap-icon name="box-arrow-right" sizeClass="text-base" colorClass="text-current" />
            Sair
          </button>
        </div>
      </div>
    </div>
  </nav>

  <div
    id="header-mobile-nav"
    class="absolute top-full right-0 left-0 z-50 border-b border-gray-200 bg-white shadow-md md:hidden"
    [class.hidden]="!isMobileNavOpen()"
    aria-labelledby="header-mobile-nav-toggle"
  >
    <div
      class="max-h-[75vh] overflow-y-auto py-1 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar]:w-2"
    >
      <button
        type="button"
        class="relative flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-gray-800 hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden"
        (click)="handleOpenNotificationsFromMobile()"
      >
        <app-bootstrap-icon name="bell-fill" sizeClass="text-base" colorClass="shrink-0 text-current" />
        <span class="min-w-0 flex-1">Notificações</span>
        @if (unreadCount() > 0) {
          <span
            class="inline-flex size-5 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-medium text-white"
          >
            {{ unreadCount() }}
          </span>
        }
      </button>

      <a
        [routerLink]="adminRoutePaths.profile"
        class="flex w-full items-center gap-3 px-4 py-3 text-sm text-gray-800 hover:bg-gray-100"
        (click)="handleCloseMobileNav()"
      >
        <app-bootstrap-icon name="person" sizeClass="text-base" colorClass="shrink-0 text-current" />
        Perfil
      </a>

      @if (isCompanyAdmin()) {
        <a
          [routerLink]="adminRoutePaths.settings"
          class="flex w-full items-center gap-3 px-4 py-3 text-sm text-gray-800 hover:bg-gray-100"
          (click)="handleCloseMobileNav()"
        >
          <app-bootstrap-icon name="gear" sizeClass="text-base" colorClass="shrink-0 text-current" />
          Configurações
        </a>
      }

      <button
        type="button"
        class="flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-gray-800 hover:bg-gray-100"
        (click)="handleLogoutFromMobile()"
      >
        <app-bootstrap-icon name="box-arrow-right" sizeClass="text-base" colorClass="shrink-0 text-current" />
        Sair
      </button>
    </div>
  </div>
</header>
